import React from "react";
import DashboardSelect from "../components/DashboardSelect";
import {
  PORTFOLIO_METRICS_OPTIONS,
  PORTFOLIO_SORT_OPTIONS,
} from "../constants/ownerPortfolio";
import {
  OwnerPortfolioQuery,
  PortfolioMetricsDays,
  PortfolioSituation,
  PortfolioSort,
} from "../types/ownerPortfolio.types";

interface PortfolioToolbarProps {
  query: OwnerPortfolioQuery;
  condominiums: string[];
  situationLabels: Record<PortfolioSituation, string>;
  onSituationChange: (situation: PortfolioSituation | null) => void;
  onCondominiumChange: (condominium: string | null) => void;
  onSortChange: (sort: PortfolioSort) => void;
  onMetricsDaysChange: (metricsDays: PortfolioMetricsDays) => void;
}

export default function PortfolioToolbar({
  query,
  condominiums,
  situationLabels,
  onSituationChange,
  onCondominiumChange,
  onSortChange,
  onMetricsDaysChange,
}: PortfolioToolbarProps) {
  const situationOptions = [
    { value: "", label: "Todas as situações" },
    ...Object.entries(situationLabels).map(([value, label]) => ({ value, label })),
  ];
  const condominiumOptions = [
    { value: "", label: "Todos os condomínios" },
    ...condominiums.map((name) => ({ value: name, label: name })),
  ];

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <DashboardSelect
        label="Situação"
        value={query.situation ?? ""}
        options={situationOptions}
        onChange={(value) =>
          onSituationChange(value === "" ? null : (value as PortfolioSituation))
        }
      />
      <DashboardSelect
        label="Condomínio"
        value={query.condominium ?? ""}
        options={condominiumOptions}
        onChange={(value) => onCondominiumChange(value === "" ? null : value)}
      />
      <DashboardSelect
        label="Ordenar"
        value={query.sort}
        options={[...PORTFOLIO_SORT_OPTIONS]}
        onChange={(value) => onSortChange(value as PortfolioSort)}
      />
      <DashboardSelect
        label="Período"
        value={String(query.metricsDays)}
        options={[...PORTFOLIO_METRICS_OPTIONS]}
        onChange={(value) => onMetricsDaysChange(Number(value) as PortfolioMetricsDays)}
      />
    </div>
  );
}
